import {lazy} from 'react'

// components

export const AssessmentGrowthDetailedReportHandler = lazy(
  () => import('./../../../../math/assessment/components/assessment-growth-detailed-report'),
)

export const ClassGroupingReportHandler = lazy(
  () => import('./../../../../math/common/components/class-grouping-report'),
)

export const ConstructedResponsePageHandler = lazy(
  () => import('./../../../../math/constructed-response/components'),
)

export const FactPracticeReportHandler = lazy(
  () => import('./../../../../math/fact-practice/components/report'),
)

export const FactPracticeReportViewHandler = lazy(
  () =>
    import('./../../../../math/fact-practice/components/report/fact-practice-report-view-handler'),
)

export const LessonAssignmentsHandler = lazy(
  () => import('./../../../../math/ibl/components/lesson/lesson-assignments'),
)

export const ChromelessLessonAssignmentsHandler = lazy(
  () => import('../../../components/add-assignment/common/chromeless-ibl-lesson-assignments'),
)

export const LessonDaysHandler = lazy(
  () => import('./../../../../math/ibl/components/lesson/lesson-days'),
)

export const LessonSlideshowHandler = lazy(
  () => import('./../../../../math/ibl/components/lesson/slideshow'),
)

export const MathAdaptiveSessionReportHandler = lazy(
  () => import('./../../../../math/adaptive/components'),
)

export const MathAssessmentGrowthReportHandler = lazy(
  () => import('./../../../../math/assessment/components/assessment-growth-report'),
)

export const MathAssessmentReportHandler = lazy(
  () => import('./../../../../math/assessment/components/assessment-report'),
)

export const MathAssignmentsHandler = lazy(
  () => import('./../../../../math/common/components/assignments'),
)

export const MathDiagnosticReportContainer = lazy(
  () => import('./../../../../math/levels-report/components/report'),
)

export const MathAdaptiveReportContainer = lazy(
  () => import('./../../../../math/adaptive-report/components/report'),
)

export const MathFactFluencyHandler = lazy(
  () => import('./../../../../math/common/components/overviews/fact-fluency-overview'),
)

export const MathLessonListHandler = lazy(
  () => import('./../../../../math/ibl/components/lesson/lesson-list'),
)

export const MathReportCardHandler = lazy(
  () => import('./../../../../math/common/components/report-cards/math-report-card'),
)

export const MathTargetedReportHandler = lazy(
  () => import('./../../../../math/targeted/components/report'),
)

export const MathTargetedSessionReportHandler = lazy(
  () => import('./../../../../math/targeted/components/session-history'),
)

export const MathFocusSkillsSessionReportHandler = lazy(
  () => import('../../../../math/focus-skills/session-report'),
)

export const PrintMathReportCardsHandler = lazy(
  () => import('./../../../../math/common/components/report-cards/print-math-report-cards'),
)

export const PrintablesWrapper = lazy(() => import('./../../../../math/printables/components'))

export const PrintablesExampleWrapper = lazy(
  () => import('../../../../math/printables/components/assignment/handlers/example'),
)

export const PrintablesAdaptiveWrapper = lazy(
  () => import('../../../../math/printables/components/assignment/handlers/adaptive'),
)

export const PrintablesTargetedWrapper = lazy(
  () => import('../../../../math/printables/components/assignment/handlers/targeted'),
)

export const ReportCardSummariesHandler = lazy(
  () => import('./../../../../math/common/components/report-cards/math-report-card-summaries'),
)

export const StandardPageHandler = lazy(
  () => import('./../../../../math/standards/components/standard-page'),
)

export const StandardStudentReportHandler = lazy(
  () => import('./../../../../math/targeted/components/standard-student-report'),
)

export const AssessmentSessionReportHandler = lazy(
  () => import('./../../../../math/assessment/components/report'),
)

export const MathTargetedAssignmentReportHandler = lazy(
  () => import('../../../../math/targeted/components/targeted-assignment-report'),
)

export const DokAssignmentReportHandler = lazy(
  () =>
    import('../../../../math/targeted-depth-of-knowledge-practice/components/dok-assignment-report'),
)

export const MathFocusSkillsAssignmentReportHandler = lazy(
  () => import('./../../../../math/focus-skills/assignment-report'),
)

export const MathOverviewHandler = lazy(
  () => import('./../../../../math/common/components/content-overview'),
)

export const MathSkillsProgressReportHandler = lazy(
  () => import('./../../../../math/common/components/skills-progress-report'),
)

export const GenericSessionReportHandler = lazy(
  () => import('../../../../common/components/session-report'),
)

export const MathPrintPreviewAssignmentHandler = lazy(
  () => import('../../../../math/common/components/print-preview'),
)
